import { Alert } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  marginBottom?: number;
};

export const MasterTableEditWarning: FC<Props> = ({ marginBottom }) => {
  const { t } = useTranslation();
  return (
    <Alert
      style={{ marginBottom }}
      message={t('warning-message-edit-master-table')}
      type="error"
    />
  );
};
